import { createSlice } from "@reduxjs/toolkit";
import getCaseTiming from "@custom/rtk-apis/Setting/getCaseTiming";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const getCaseTimingSlice = createSlice({
    name: "getCaseTimingSlice",
    initialState,
    reducers: {
        clearGetCaseTimingState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCaseTiming.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getCaseTiming.fulfilled, (state, { payload }) => {
                console.log("🚀 ~ .addCase ~ payload:", payload)
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(getCaseTiming.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default getCaseTimingSlice.reducer;
export const { clearGetCaseTimingState } = getCaseTimingSlice.actions;
